import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
// Import images
import { useQuery } from '@tanstack/react-query';
// import avatar1 from '../../assets/images/users/avatar-1.jpg';
import Icon from '@mdi/react';
import { mdiChevronDown } from '@mdi/js';
import Avatar from 'react-avatar';
import { getCompanyCode, logoutUser } from '../../config/axios.config';
import { getAuthUser } from '../../utils/auth.util';
import { fetchEmployeeProfilePicture } from '../../store/apis/employeeService';

function ProfileDropdown() {
  const location = useLocation();
  const { id, userName, employeeId } = getAuthUser();
  const companyCode = getCompanyCode();
  // Find if current path has 'hr' in it
  const isHRPath = location.pathname.includes('/hr');

  // Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };
  const { userFullName, canViewHR, canViewSelfService } = getAuthUser();

  const { data: employeeProfilePicture } = useQuery({
    queryKey: ['employeeProfilePicture'],
    queryFn: () =>
      fetchEmployeeProfilePicture({
        userId: id,
        employeeId: userName?.toUpperCase() || employeeId,
        companyCode,
      }),
  });

  const renderCrossDashboardLink = () => {
    const hasHR = String(canViewHR).toLowerCase() === 'yes';
    const hasSS = String(canViewSelfService).toLowerCase() === 'yes';

    // Only show cross-nav when BOTH are available
    if (!(hasHR && hasSS)) return null;

    const linkPath = isHRPath
      ? '/dashboard' // currently in HR → link to Self-Service
      : '/hr/dashboard'; // currently in Self-Service → link to HR

    const label = isHRPath ? 'Self-Service' : 'HR Dashboard';

    return (
      <DropdownItem className="p-0">
        <Link to={linkPath} className="dropdown-item">
          <i className="mdi mdi-account-settings text-muted fs-16 align-middle me-1" />
          <span className="align-middle">{label}</span>
        </Link>
      </DropdownItem>
    );
  };

  return (
    <Dropdown
      isOpen={isProfileDropdown}
      toggle={toggleProfileDropdown}
      className="ms-sm-3 topbar-user"
    >
      <DropdownToggle tag="button" type="button" className="btn">
        <span className="d-flex align-items-center">
          <Avatar
            round
            name={userFullName || 'Unknown'}
            size="1.85rem"
            color="#CFCBDC"
            fgColor="#475467"
            maxInitials={2}
            style={{
              fontSize: '14px',
              fontWeight: '600',
            }}
            src={employeeProfilePicture}
          />
          <span className="text-start ms-xl-2">
            <span className="d-none d-xl-inline-block ms-1 fw-bold user-name-text">
              {userFullName}
            </span>
            <Icon path={mdiChevronDown} size={0.7} />
          </span>
        </span>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <h6 className="dropdown-header">
          Welcome {userFullName?.split(' ')?.[0]}!
        </h6>
        <DropdownItem className="p-0">
          <Link to="/profile" className="dropdown-item">
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1" />
            <span className="align-middle">Profile</span>
          </Link>
        </DropdownItem>
        {renderCrossDashboardLink()}
        <div className="dropdown-divider" />
        <DropdownItem className="p-0">
          <div
            role="button"
            className="dropdown-item"
            onClick={logoutUser}
            style={{ cursor: 'pointer' }}
            tabIndex="0" // Makes the div focusable
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                logoutUser(); // Trigger logout on Enter or Space key press
              }
            }}
          >
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />
            <span className="align-middle" data-key="t-logout">
              Logout
            </span>
          </div>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

export default ProfileDropdown;
